import React, {useCallback} from "react";
import {Modal} from "components";
import styled from "styled-components";
import {handleModalState} from "apps/DRAW_PREDICTOR/modules/actions/modals";
import {useDispatch, useSelector} from "react-redux";
import {ReactComponent as SwitchIcon} from "apps/DRAW_PREDICTOR/assets/images/icons/switch.svg";
import {useTranslation} from "react-i18next";
import {LANGUAGE_PATH} from "modules";
import {CancelButton, PrimaryButton} from "apps/DRAW_PREDICTOR/components/Buttons";
import {
	getPredictionAndGroupBySquadId,
	getSquad2ForEditId,
	getSquadForEditId,
	getSquadsById,
	showEditPick,
} from "apps/DRAW_PREDICTOR/modules/selectors";
import {clearEditPredictionData, editPrediction} from "apps/DRAW_PREDICTOR/modules/actions";

const ModalInner = styled.div`
	text-align: center;
	padding: 20px;

	h2 {
		font-family: "Qatar2022", sans-serif;
		font-style: normal;
		font-weight: bold;
		font-size: 25px;
		line-height: 120%;
		margin: 30px auto 10px;
		max-width: 460px;
	}

	h3 {
		max-width: 500px;
		font-family: "Graphik", sans-serif;
		font-style: normal;
		font-weight: normal;
		font-size: 18px;
		line-height: 160%;
		margin: 0 auto 20px;
	}
`;

const Buttons = styled.div`
	margin-top: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 20px;
`;

export const EditPredictionModal: React.FC = () => {
	const dispatch = useDispatch();
	const {t} = useTranslation(LANGUAGE_PATH);
	const show = useSelector(showEditPick);
	const squadsById = useSelector(getSquadsById);

	const predictionSquad1ForEdit = useSelector(getSquadForEditId);
	const predictionSquad2ForEdit = useSelector(getSquad2ForEditId);

	const predictionSquad1Data = useSelector(getPredictionAndGroupBySquadId)(
		predictionSquad1ForEdit
	);
	const predictionSquad2Data = useSelector(getPredictionAndGroupBySquadId)(
		predictionSquad2ForEdit
	);

	const handleModalClose = useCallback(() => {
		dispatch(handleModalState({showEditPickModal: false}));
		dispatch(clearEditPredictionData());
	}, [dispatch]);

	const confirmEditPrediction = useCallback(() => {
		dispatch(editPrediction(squadsById));
		handleModalClose();
	}, [dispatch, handleModalClose, squadsById]);

	if (!show) {
		return null;
	}

	return (
		<Modal onClose={handleModalClose}>
			<ModalInner>
				<SwitchIcon />
				<h2>{t("modal.switch.confirm_header")}</h2>
				<h3>
					{t("modal.switch.confirm_body", {
						country1: predictionSquad1Data.squad?.name,
						country2: predictionSquad2Data.squad?.name,
						group1: predictionSquad1Data.prediction?.namegroup.toUpperCase(),
						group2: predictionSquad2Data.prediction?.namegroup.toUpperCase(),
					})}
				</h3>

				<Buttons>
					<PrimaryButton onClick={confirmEditPrediction}>
						{t("modal.switch.confirm_button")}
					</PrimaryButton>
					<CancelButton onClick={handleModalClose}>{t("pot.button.cancel")}</CancelButton>
				</Buttons>
			</ModalInner>
		</Modal>
	);
};
